import React, { SyntheticEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  getAteLayerAction,
  resetAteListAction,
  selectATEAction,
  setCurrentAteAction,
  setSearchWktAction,
} from 'store/actions/layers';
import { getText } from 'services/languageService';
import { getLastAte } from 'components/UI/AteBlock/constants';
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteValue,
  Box,
  TextField,
} from '@mui/material';

export const AteBlock: React.FC<{ hideVC?: boolean; type?: string }> = ({
  hideVC,
  type,
}) => {
  const {
    ateCities,
    ateVC,
    ateRegions,
    currAteCity,
    currAteVC,
    currAteRegion,
    searchWkt,
  } = useAppSelector((state) => state.layers);

  const dispatch = useAppDispatch();

  const handleChangeRegion = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value) {
      dispatch(setCurrentAteAction('currAteCity', null));
      dispatch(setCurrentAteAction('currAteVC', null));
      dispatch(setCurrentAteAction('currAteRegion', value));

      dispatch(
        getAteLayerAction(
          'ateCities',
          {
            regions: [value],
            cities: [],
            vc: [],
          },
          undefined,
          type === 'search'
        )
      );
    } else {
      dispatch(setCurrentAteAction('currAteRegion', value));
      dispatch(resetAteListAction('ateCities', 'currAteCity'));
      dispatch(resetAteListAction('ateVC', 'currAteVC'));
      !hideVC && dispatch(setSearchWktAction(true)); //for search wkt
    }
  };

  const handleChangeCities = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    dispatch(setCurrentAteAction('currAteCity', value));
    if (value) {
      dispatch(
        getAteLayerAction(
          'ateVC',
          {
            regions: [],
            cities: [value],
            vc: [],
          },
          undefined,
          type === 'search'
        )
      );
      dispatch(setCurrentAteAction('currAteVC', null));
    } else {
      dispatch(resetAteListAction('ateVC', 'currAteVC'));
      !hideVC && dispatch(setSearchWktAction(true)); //for search wkt
    }
  };

  const handleChangeVC = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    dispatch(setCurrentAteAction('currAteVC', value));
    dispatch(setSearchWktAction(true)); //for search wkt
    if (!value) {
      dispatch(setCurrentAteAction('currAteVC', null));
    }
  };

  useEffect(() => {
    if (!searchWkt || hideVC) return;
    const ate = getLastAte(currAteRegion, currAteCity, currAteVC);

    ate && dispatch(selectATEAction(ate));
    dispatch(setSearchWktAction(false));
  }, [searchWkt]);

  return (
    <Box>
      <Autocomplete
        value={currAteRegion}
        id="controllable-states-demo"
        size={'small'}
        fullWidth
        options={ateRegions}
        onChange={handleChangeRegion}
        sx={{ mb: 1, p: '8px 16px 0 16px' }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField label={getText('ATE_REGIONS')} {...params} />
        )}
      />

      <Autocomplete
        value={currAteCity}
        id="controllable-states-demo"
        size={'small'}
        fullWidth
        options={ateCities}
        onChange={handleChangeCities}
        sx={{ mb: 1, p: '0 16px' }}
        disabled={!ateCities.length || !currAteRegion || !currAteRegion.id}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField label={getText('ATE_CITIES')} {...params} />
        )}
      />

      {!hideVC ? (
        <Autocomplete
          value={currAteVC}
          id="controllable-states-demo"
          size={'small'}
          fullWidth
          options={ateVC}
          onChange={handleChangeVC}
          sx={{ p: '0 16px' }}
          disabled={!ateVC.length || !currAteCity || !currAteCity.id}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField label={getText('ATE_VC')} {...params} />
          )}
        />
      ) : null}
    </Box>
  );
};
